import React from "react";
import ScaleLoader from 'react-spinners/ScaleLoader';

const AppLoader = () => {
    const styles = {
        'display': 'flex',
        'justifyContent': 'center',
        'alignItems': 'center',
        'position': 'fixed',
        'top': 0,
        'left': 0,
        'backgroundColor': 'rgba(0, 0, 0, 0.35)',
        'zIndex': '99999',
        'width': '100%',
        'height': '100%'
    };
    return (
        <div style={styles}>
            <ScaleLoader />
        </div>
    );
}

export default AppLoader;